import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CategoryItem } from './component/client-detail/category-item';
import { Category } from './model/category';
import { User } from './model/user';

export class SetUser {
    static readonly type = '[AppState] SetUser';
    constructor(public user: User) { }
}

export class ResetUser {
    static readonly type = '[AppState] ResetUser';
}

export class SetCategories {
    static readonly type = '[AppState] SetCategories';
    constructor(public categories: CategoryItem[]) { }
}

export interface AppStateModel {
    user: User;
    categories: CategoryItem[];
}

@State<AppStateModel>({
    name: 'app',
    defaults: {
        user: null,
        categories: []
    }
})
@Injectable()
export class AppState {

    @Selector()
    static user(state: AppStateModel) {
        return state.user;
    }

    @Selector()
    static username(state: AppStateModel) {
        return state.user.username;
    }

    @Selector()
    static isUserAdmin(state: AppStateModel) {
        if (state.user.roles.find(item => item.name == 'ROLE_ADMIN')) return true;
        if (state.user.roles.find(item => item.name == 'ROLE_USER')) return false;
        return null;
    }

    @Selector()
    static categories(state: AppStateModel) {
        return state.categories;
    }

    @Action(SetUser)
    setUser(ctx: StateContext<AppStateModel>, action: SetUser) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            user: action.user
        });
    }

    @Action(ResetUser)
    resetUser(ctx: StateContext<AppStateModel>) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            user: null
        });
    }

    @Action(SetCategories)
    setCategories(ctx: StateContext<AppStateModel>, action: SetCategories) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            categories: action.categories
        });
    }

}